// extracted by mini-css-extract-plugin
export default {"popup":"chatConfirmationPopup_popup__HTiZs","popup__title":"chatConfirmationPopup_popup__title__-9GYs","popup__nextBtn":"chatConfirmationPopup_popup__nextBtn__MCjbQ"};